<template>
  <v-autocomplete
    ref="autocomplete"
    outlined
    filled
    hide-details
    hide-no-data
    :items="getCorporationsList"
    item-text="name"
    :placeholder="$t('components.corporationSelect.selectCorporation')"
    :disabled="disabled"
    :clearable="isClearable"
    :height="44"
    dense
    :loading="corporationsLoading"
    v-model="selectedCorporation"
    class="bs-search-item"
    background-color="#ffffff"
    return-object
    :search-input.sync="search"
    @change="onCorporationChange"
  >
    <template v-slot:prepend-inner>
      <department-icon/>
    </template>
    <template v-slot:append>
      <v-icon>mdi-chevron-down</v-icon>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters } from 'vuex';
import * as CorporationCommands from "./corporations.mixin";
import { iconLoader } from '@/helpers/iconsLoader';

const { sideMenu } = iconLoader;

export default {
  name: 'CorporationsSelector',
  components: {
    ...sideMenu,
  },
  props: {
    isClearable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    search: '',
    selectedCorporation: null,
    corporationsLoading: false,
  }),
  computed: {
    ...mapGetters({
      getCorporationsList: 'corporations/getCorporationsList',
      getSelectedCorporationId: 'corporations/getSelectedCorporationId',
    }),
  },
  async created() {
    this.corporationsLoading = true;

    const { success, error } = await CorporationCommands.loadCorporations();
    
    if (success) {
      await CorporationCommands.checkIfHasLocalCorporation();
      this.corporationsLoading = false;
    } else {
      this.corporationsLoading = false;
      // this.$store.dispatch('snackbar/showError', error);
    }
  },
  methods: {
    async onCorporationChange() {
      CorporationCommands.setSelectedCorporationId(this.selectedCorporation.id);
    },
  },
}
</script>

<style lang="scss" scoped>

</style>